import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Loading from './pages/loading';
import PageWrapper from './PageWrapper';
import Tickets from './pages/tickets';

const Home = lazy(() => import('./pages/home'));
const About = lazy(() => import('./pages/about'));
// const Tickets = lazy(() => import('./pages/tickets'));
const Events = lazy(() => import('./pages/events'));
const Contact = lazy(() => import('./pages/contact'));
const Error404 = lazy(() => import('./pages/error'));

function Paths() {
    return (
        <BrowserRouter>
            <PageWrapper>
                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={ <About /> } />
                        <Route path="/tickets" element={<Tickets />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Error404 />} />
                    </Routes>
                </Suspense>
            </PageWrapper>
        </BrowserRouter>
    );
}

export default Paths;